export const deletePhoto = 'Delete Photo'
export const profilePicture = 'Profile Picture'
export const captureImage = 'Capture Image'
export const uploadImage = 'Upload Photo'
export const doctorImage = 'Image'
export const doctorSignature = 'Signature'
export const captureMode = 'capture'
export const uploadMode = 'upload'
export const crhealthcare =
  'CR Healthcare Services Pvt Ltd* (CIN - U85110TG2021PTC153300)'
export const departments = 'Departments'
export const doctors = 'Doctors'
export const locationtext = 'Locations'
export const pathologist = 'Pathologist'
export const CreateMembership = 'Create Membership'
export const LoadingMsg = 'Creating...'
export const sxpElements = {
  town: 'town',
  postalCode: 'postalCode',
  occupation: 'occupation',
  patientSource: 'patientSource',
  ped: 'ped',
}
export const RegistrationTypes = {
  full: 'fr',
  membershipPrimary: 'membershipPrimary',
  ABMembershipFull: 'ABMembershipFull',
  er: 'er',
  camp: 'camp',
  package: 'package',
  quick: 'qr',
}
export const ERROR_PATIENT_REGISTRATION_MEDIA =
  'Error Patient While Capturing-----'
export const CompanyErrorMsg = 'Error fetching companies:'
export const companyendPoint = '/company'
export const REGISTRATION_TYPE_BY_SERVICE: Record<string, string> = {
  fr: 'FULL',
  qr: 'QUICK',
  er: 'ER',
  lab: 'LABORATORY',
  pmc: 'PHARMACY',
  dgs: 'DIAGNOSTIC',
  camp: 'CAMPAIGN',
  membership: 'MEMBERSHIP',
  membershipPrimary: 'MEMBERSHIP',
  ABMembershipFull: 'AB_MEMBERSHIP',
  ABMembershipQuick: 'AB_MEMBERSHIP',
  package: 'PACKAGE',
}
export const specifyRelationship = 'specifyRelationship'
export const Others = 'Others'
export const permanentAddressConfirmation = 'permanentAddressConfirmation'
export const REGISTRATION_FIELD_STATE = 'state'
export const REGISTRATION_FIELD_CHECKBOX = 'checkbox'
export const REGISTRATION_FIELD_DOB = 'dob'
export const REGISTRATION_FIELD_AGE = 'age'
export const REGISTRATION_FIELD_SAME_AS_CURRENT_ADDRESS = 'sameAsCurrentAddress'
export const PERMANENT_ADDRESS_FIELDS: Record<string, string> = {
  houseNo: 'permanentHouseNo',
  area: 'permanentArea',
  town: 'permanentTown',
  state: 'permanentState',
  district: 'permanentDistrict',
  postalCode: 'permanentPostalCode',
}
export const PROFILE_PICTURE_UPLOAD_FILE_NAME = 'profile.jpeg'
export const PROFILE_PICTURE_UPLOAD_RESPONSE_MISSING_FILE_KEY =
  'Upload response did not include file key'
export const PROFILE_PICTURE_UPLOAD_FAILED = 'Failed to upload profile picture'
export const PROFILE_PICTURE_CAMERA_PERMISSION_DENIED =
  'Camera permission denied'
export const PROFILE_PICTURE_CAPTURE_UPLOAD_FAILED =
  'Failed to capture and upload profile picture'
export const PROFILE_PICTURE_ADD_PHOTO = 'Add Photo'
export const PROFILE_PICTURE_UPDATE_TITLE = 'Update Profile Picture'
export const PROFILE_PICTURE_SELECT_CAMERA = 'Select Camera'
export const PROFILE_PICTURE_UPLOAD_FROM_DEVICE = 'Upload from Device'
export const PROFILE_PICTURE_CANCEL = 'Cancel'
export const REGISTRATION_FIELD_SALUTATION = 'salutation'
export const REGISTRATION_FIELD_GENDER = 'gender'
export const REGISTRATION_FIELD_DISTRICT = 'district'
export const REGISTRATION_DEFAULT_SERVICE = 'fr'
export const PATIENTS_ROUTE = '/patients'
export const SALUTATION_GENDER_MAP: Record<string, string> = {
  mr: 'male',
  master: 'male',
  baby: 'male',
  babyof: 'male',
  mrs: 'female',
  miss: 'female',
}
